import { Component, OnInit } from '@angular/core';
import { LaunchService } from '../launch.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.css']
})
export class RegionComponent implements OnInit {
  dataKey: string = '';
  loaded: boolean = false;
  configData: any = {};
  selectedRegion: any = {};
  webApps: any = [];
  rdpApps: any = [];
  appDefinitions: any = {
    trinity: {
      "type": "web",
      "displayName": "Trinity",
      "description": "Electronic Health Record application with scheduling, referral management, and office workflow tools",
      "imageUrl": "app_trinity.png"
    },
    carebook: {
      "type": "web",
      "displayName": "Evoke360",
      "description": "Population Health application with clinical/financial reports, ScoreCard, PRM, and other modules",
      "imageUrl": "app_carebook.png"
    },
    rae: {
      "type": "rdp",
      "displayName": "RAE",
      "description": "Remote application link for Referrals and Encounters program",
      "imageUrl": "app_rae.png"
    },
    sfs: {
      "type": "rdp",
      "displayName": "SFS",
      "description": "Remote application link for Service Fund Solutions reporting tool",
      "imageUrl": "app_sfs.png"
    },
    billing: {
      "type": "rdp",
      "displayName": "Billing",
      "description": "Remote application link for EZClaim billing program",
      "imageUrl": "app_billing.png"
    }
  };

  constructor(private launchService: LaunchService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.dataKey = params['dataKey'];
      this.getRegion();
      if (localStorage) {
        localStorage.setItem('selected-region', this.dataKey);
      }
    });
  }

  getRegion() {
    this.configData = null;
    this.webApps = [];
    this.rdpApps = [];
    this.launchService.getConfig().then(data => {
      this.configData = data;
      this.selectedRegion = this.configData.regions.find(x => x.dataKey.toLowerCase() === this.dataKey.toLowerCase());

      if (!this.selectedRegion) {
        console.log('selected region is invalid');
        this.router.navigate(['']);
        return;
      }

      this.selectedRegion.apps
        .sort(function (a, b) {
          return a.dataKey.localeCompare(b.dataKey);
        });

      this.selectedRegion.apps.forEach((app) => {
        let def = this.appDefinitions[app.dataKey];
        if (!def) {
          return;
        }
        app.type = def.type;
        app.displayName = def.displayName;
        app.description = def.description;

        if (app.type === 'web') {
          this.webApps.push(app);
        }
        else {
          this.rdpApps.push(app);
        }
      });

      this.loaded = true;
    });
  }

}
